import { Box, Button, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { openDialog } from "../../features/dialog";

function UserButtonBar({selection, search, setSearch}){
    const dispatch = useDispatch();

    return <Box justifyContent="space-between" display="flex">
    <Box flexGrow={0}>
        <TextField
            size="small"
            fullWidth
            autoFocus
            placeholder="Search user"
            value={search}
            label="Filter by name or email"
            onChange={e => setSearch(e.target.value)}
            InputLabelProps={{
                shrink: true
            }}
        />
    </Box>
    <Box display="flex" gap={2} alignItems="center">

        {selection && selection.length > 0 && <Button 
            color="error" 
            variant="outlined"
            onClick={() => {
                dispatch(openDialog({id: "deleteUser", props: selection.length === 1 ? selection[0] : selection}));
            }}
        >Delete selected</Button> }

        {selection && selection.length > 0 && <Button 
            color="warning" 
            variant="outlined"
            onClick={() => {
                dispatch(openDialog({id: "deactivateUser", props: selection.length === 1 ? selection[0] : selection}));
            }}
        >Deactivate selected</Button> }

        {selection && selection.length > 0 && <Button 
            color="success" 
            variant="outlined"
            onClick={() => {
                dispatch(openDialog({id: "activateUser", props: selection.length === 1 ? selection[0] : selection}));
            }}
        >Activate selected</Button> }
        <Button variant="contained" color="secondary" onClick={() => dispatch(openDialog("newUser"))}>Add User</Button>
    </Box>
</Box>
}
export default UserButtonBar;